import * as React from 'react';

import { InvestmentActivity } from '../../../__generated__/globalTypes';

import { TransactionFilterDropdown, type IFilterOption } from './TransactionFilterDropdown';

// In display order. The dropdown sorts by `sortKey` once it opens.
const ACTIVITY_OPTIONS: IFilterOption[] = [
  { id: InvestmentActivity.Trade, label: 'Trades' },
  { id: InvestmentActivity.Income, label: 'Income' },
  { id: InvestmentActivity.MoneyMovement, label: 'Money in & out' },
  { id: InvestmentActivity.Fee, label: 'Fees' },
  { id: InvestmentActivity.Other, label: 'Other' },
].map((option, index) => ({ ...option, sortKey: String(index) }));

interface IInvestmentActivityFilterDropdownProps {
  /** Null shows all activity. */
  selectedActivity: InvestmentActivity | null;
  onSelect: (activity: InvestmentActivity | null) => void;
}

/**
 * The investment transactions table's activity filter: an "Activity" button that opens a
 * single-select list of the activity groups. Clearing the selection shows all activity.
 */
export const InvestmentActivityFilterDropdown = ({
  selectedActivity,
  onSelect,
}: IInvestmentActivityFilterDropdownProps) => {
  const selectedIds = React.useMemo(() => (selectedActivity ? [selectedActivity] : []), [selectedActivity]);

  return (
    <TransactionFilterDropdown
      label="Activity"
      options={ACTIVITY_OPTIONS}
      selectedIds={selectedIds}
      onSelect={(ids) => onSelect((ids[0] as InvestmentActivity | undefined) ?? null)}
      hideSearch
      className="h-auto"
      selectionMode="single"
    />
  );
};
